@if (options) {
  <div [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    <!-- SNIPPETS -->
    @if (options?.request === 'snippet') {
      <div class="lm-header-container">
        <div class="field lm-rule-type">
          <label soho-label for="ruleType">{{ 'LPL_EDITOR_RULE_TYPE' | translate }}</label>
          <select soho-dropdown
            id="ruleType"
            name="ruleType"
            data-automation-id="lm-repository-helper-rule-Type"
            (change)="onSnippetRuleTypeChange()"
            [(ngModel)]="ruleType"
            soho-alert>
            @for (obj of ruleTypeObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
        <div class="field lm-securable-type">
          <label soho-label for="snippet">{{ 'LPL_EDITOR_SECURABLE_TYPE' | translate }}</label>
          <select soho-dropdown
            id="snippet"
            name="snippet"
            data-automation-id="lm-repository-helper-snippet"
            (change)="onSnippetChange()"
            [(ngModel)]="snippet"
            soho-alert>
            @for (obj of snippetObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
      </div>
    }
    <!-- OBJECT LOOKUP -->
    @if (options?.request === 'objects') {
      <div class="lm-header-container">
        <div class="field lm-securable-type">
          <label soho-label for="objectSecurableType">{{ 'LPL_EDITOR_SECURABLE_TYPE' | translate }}</label>
          <select soho-dropdown
            id="objectSecurableType"
            name="objectSecurableType"
            data-automation-id="lm-repository-helper-securable-type"
            (change)="onObjectTypeChange()"
            [(ngModel)]="securableType"
            soho-alert>
            @for (obj of securableTypeObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
        @if (hasContainment) {
          <div class="field lm-containment">
            <label soho-label for="objectContainment">{{containmentLabel}}</label>
            <select soho-dropdown
              id="objectContainment"
              name="objectContainment"
              data-automation-id="lm-repository-helper-containment"
              [source]="containmentSource"
              (change)="onObjectContainmentChange()"
              [(ngModel)]="containment"
              soho-alert>
              @for (obj of containmentObjects; track obj) {
                <option [value]="obj.value">{{obj.label}}</option>
              }
            </select>
          </div>
        }
        <div class="field lm-securable-type">
          <label soho-label for="securableObject">{{ 'LPL_EDITOR_SECURABLE_OBJECT' | translate }}</label>
          <select soho-dropdown
            id="securableObject"
            name="securableObject"
            data-automation-id="lm-repository-helper-securable-object"
            [source]="securableObjectSource"
            (change)="onSecurableObjectChange()"
            [(ngModel)]="securableObject"
            soho-alert>
            @for (obj of securableObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
      </div>
    }
    <!-- ACTION LIST -->
    @if (options?.request === 'actions') {
      <div class="lm-header-container">
        <div class="field lm-rule-type">
          <label soho-label for="actionRuleType">{{ 'LPL_EDITOR_RULE_TYPE' | translate }}</label>
          <select soho-dropdown
            id="actionRuleType"
            name="actionRuleType"
            data-automation-id="lm-repository-helper-rule-Type"
            (change)="onActionRuleTypeChange()"
            [(ngModel)]="ruleType"
            soho-alert>
            @for (obj of ruleTypeObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
        <div class="field lm-securable-type">
          <label soho-label for="securableType">{{ 'LPL_EDITOR_SECURABLE_TYPE' | translate }}</label>
          <select soho-dropdown
            id="securableType"
            name="securableType"
            data-automation-id="lm-repository-helper-securable-type"
            (change)="onSnippetChange()"
            [(ngModel)]="snippet"
            soho-alert>
            @for (obj of snippetObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
        @if (hasContainment) {
          <div class="field lm-containment">
            <label soho-label for="securableObject">{{containmentLabel}}</label>
            <select soho-dropdown
              id="containment"
              name="containment"
              data-automation-id="lm-repository-helper-containment"
              [source]="containmentSource"
              (change)="onActionContainmentChange()"
              [(ngModel)]="containment"
              soho-alert>
              @for (obj of containmentObjects; track obj) {
                <option [value]="obj.value">{{obj.label}}</option>
              }
            </select>
          </div>
        }
      </div>
      <div class="row">
        <soho-swaplist
          class="lm-swap-list-items"
          id="items"
          data-automation-id="lm-repository-helper-items"
          [availableCardTitle]="availableItemsHeader"
          [selectedCardTitle]="selectedItemsHeader"
          [availableItems]="availableItems"
          [selectedItems]="currentItems"
          (updated)="onSwapListUpdated($event)">
        </soho-swaplist>
      </div>
    }
    <!-- FIELD LIST -->
    @if (options?.request === 'fields') {
      <div class="lm-header-container">
        <div class="field lm-containment">
          <label soho-label for="fieldContainment">{{containmentLabel}}</label>
          <select soho-dropdown
            id="fieldContainment"
            name="fieldContainment"
            data-automation-id="lm-repository-helper-containment"
            [source]="containmentSource"
            (change)="onFieldsContainmentChange()"
            [(ngModel)]="containment"
            soho-alert>
            @for (obj of containmentObjects; track obj) {
              <option [value]="obj.value">{{obj.label}}</option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <soho-swaplist
          class="lm-swap-list-items"
          id="fields"
          data-automation-id="lm-repository-helper-items"
          [availableCardTitle]="availableItemsHeader"
          [selectedCardTitle]="selectedItemsHeader"
          [availableItems]="availableItems"
          [selectedItems]="currentItems"
          (updated)="onSwapListUpdated($event)">
        </soho-swaplist>
      </div>
    }
    <!-- FIELD LIST -->
    @if (options?.request === 'ontology') {
      <div class="row">
        <soho-swaplist
          class="lm-swap-list-items"
          id="ontologies"
          data-automation-id="lm-repository-helper-items"
          [availableCardTitle]="availableItemsHeader"
          [selectedCardTitle]="selectedItemsHeader"
          [availableItems]="availableItems"
          [selectedItems]="currentItems"
          (updated)="onSwapListUpdated($event)">
        </soho-swaplist>
      </div>
    }
    <!-- FIELD LIST -->
    @if (options?.request === 'conditionBuilder') {
      <div class="field">
        <label soho-label for="conditionContainment">{{containmentLabel}}</label>
        <select soho-dropdown
          id="conditionContainment"
          name="conditionContainment"
          data-automation-id="lm-repository-helper-containment"
          [source]="containmentSource"
          (change)="onConditionBuilderContainmentChange()"
          [(ngModel)]="containment"
          soho-alert>
          @for (obj of containmentObjects; track obj) {
            <option [value]="obj.value">{{obj.label}}</option>
          }
        </select>
      </div>
      <div class="lm-filter-build-container">
        <lm-filter-builder #FilterBuilder
          [businessClass]="containment"
          [includeAuditFields]="true"
          [lookupUrl]="fieldLookupUrl"
          [fieldSearchUrl]="fieldSearchUrl"
          [lplValidationUrl]= "lplValidationUrl">
        </lm-filter-builder>
      </div>
    }
    <!-- PREVIEW -->
    @if (options?.request !== 'conditionBuilder') {
      <div class="lm-preview-container">
        <div class="field">
          <label soho-label for="preview">{{ 'LPL_EDITOR_PreviewLabel' | translate }}</label>
          <textarea #previewComponent
            [ngClass]="options?.request === 'snippet' ? 'lm-snippet-preview-text' : 'lm-preview-text'"
            class="lm-preview-text"
            id = "preview"
            name="preview"
            data-automation-id="lm-repository-helper-preview"
            spellcheck="false"
            soho-textarea
            readonly="true"
            [resizable]="true"
            (keydown)="false"
            [(ngModel)]="preview"
          ></textarea>
        </div>
        <button
          soho-button="modal-primary"
          icon="copy"
          title="{{ 'Copy' | translate }}"
          data-automation-id="lm-repository-copy-btn"
          (click)="copyToClipboard(previewComponent)"
        >{{ 'Copy' | translate }}</button>
      </div>
    }
  </div>
}
